module.exports = __webpack_public_path__ + "media/images/pic/helpfull_lectors-e27936912ab76f7b5730db23b9eaef4d.svg";